const mapping: Record<string, string> = {
  id: 'e=>e.Id',
  note: 'e=>e.Note',
}

export const mapSortEntranceParam = (key: string) => mapping[key]
